import { ShieldAlert } from 'lucide-react'
import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
} from '@/common/ui/alert-dialog'
import { Button } from '@/common/ui/button'

interface RtpConfirmDialogProps {
	open: boolean
	onOpenChange: (open: boolean) => void
	onConfirm: () => void
	confirmLabel?: string
	isPending?: boolean
}

export function RtpConfirmDialog({
	open,
	onOpenChange,
	onConfirm,
	confirmLabel = 'ยืนยัน',
	isPending = false,
}: RtpConfirmDialogProps) {
	return (
		<AlertDialog open={open} onOpenChange={onOpenChange}>
			<AlertDialogContent>
				<AlertDialogHeader>
					<AlertDialogTitle className="flex items-center gap-2">
						<ShieldAlert className="h-5 w-5 text-amber-500" />
						ตรวจสอบการตั้งค่า RTP ก่อนบันทึก
					</AlertDialogTitle>
					<AlertDialogDescription asChild>
						<div className="space-y-3 text-sm">
							<p>กรุณาตรวจสอบให้แน่ใจว่า:</p>
							<ul className="space-y-2">
								<li className="flex items-start gap-2">
									<span className="mt-0.5 shrink-0 font-bold text-amber-600">
										1.
									</span>
									<span>
										ตั้งค่า RTP Preset แล้ว และค่า RTP เหมาะสมกับโบนัสและเทิร์น
										เพื่อให้ผู้เล่นเหลือเครดิตน้อยกว่าเงินที่ฝากมาหลังเคลียร์เทิร์น
									</span>
								</li>
								<li className="flex items-start gap-2">
									<span className="mt-0.5 shrink-0 font-bold text-amber-600">
										2.
									</span>
									<span>
										ค่ายเกมที่เลือกรองรับระบบ{' '}
										<strong className="text-foreground">ปรับแตก</strong>{' '}
										มิฉะนั้นการตั้งค่า RTP จะไม่มีผลและอาจขาดทุน
									</span>
								</li>
							</ul>
						</div>
					</AlertDialogDescription>
				</AlertDialogHeader>
				<AlertDialogFooter>
					<AlertDialogCancel>กลับไปตรวจสอบ</AlertDialogCancel>
					<AlertDialogAction asChild>
						<Button onClick={onConfirm} disabled={isPending}>
							{isPending ? 'กำลังบันทึก...' : confirmLabel}
						</Button>
					</AlertDialogAction>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	)
}

interface RtpSubmitButtonProps {
	onRequestSubmit: () => void
	label: string
	size?: 'default' | 'sm' | 'lg' | 'icon'
	className?: string
	disabled?: boolean
}

export function RtpSubmitButton({
	onRequestSubmit,
	label,
	size = 'default',
	className,
	disabled,
}: RtpSubmitButtonProps) {
	return (
		<Button
			type="button"
			variant="default"
			size={size}
			className={className}
			disabled={disabled}
			onClick={onRequestSubmit}
		>
			{label}
		</Button>
	)
}
